import { action } from 'satcheljs';

export const getPremiumUser = action('getPremiumUser');
